import { ButtonProps } from '../Button/Button';

export enum ListSelectionType {
  None = 'none',
  Single = 'single',
  Multi = 'multi',
}

export interface ListProps {
  entries: ListEntryProps[];
  className?: string;
  selectionType?: ListSelectionType;
  selectedIndices?: number[];
  onSelectionChange?: (selected: number[]) => void;
}

export interface VirtualizedListProps extends ListProps {
  selectedEntries: number[];
}

export type ListButtonProps = ButtonProps & {
  'data-testid'?: string;
  'aria-label'?: string;
};

export interface ListEntryProps {
  // Label of the list current entry
  label: string;
  // Text to show below the entry label
  content?: React.ReactNode;
  // Buttons that trigger different actions for the current list entry
  actions?: ListButtonProps[];
  // Avatar to be displayed in front of the list item
  avatar?: JSX.Element;
  // Marks the entry optically as disabled
  disabled?: boolean;
  // Adds additional css class names to the label
  labelClassName?: string;
  // Adds additional css class names to the label
  labelWrapperClassName?: string;
  // Set to false, to disallow user selection
  selectionDisabled?: boolean;
}
